
import React from "react";
import styled from "styled-components";
import {
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMessageCircle,
  FiPhone,
  FiMail,
  FiMapPin,
  FiArrowRight
} from "react-icons/fi";



const FooterWrapper = styled.footer`

position:relative;


background:

linear-gradient(
135deg,
#0F172A,
#020617
);


color:white;


padding:5.5rem 1.5rem 2rem;


overflow:hidden;



&::before{

content:"";

position:absolute;

width:450px;

height:450px;

border-radius:50%;

background:${({theme})=>theme.colors.primary};

opacity:.08;

top:-200px;

right:-150px;

}



`;



const Container = styled.div`

max-width:1280px;

margin:auto;

position:relative;

z-index:1;

`;





const FooterGrid = styled.div`

display:grid;


grid-template-columns:1.5fr 1fr 1fr;


gap:4rem;


margin-bottom:4rem;



@media(max-width:${({theme})=>theme.breakpoints.desktop}){

grid-template-columns:1fr 1fr;

}



@media(max-width:${({theme})=>theme.breakpoints.mobile}){

grid-template-columns:1fr;

gap:2.5rem;

}

`;





const BrandColumn = styled.div`

max-width:380px;

`;





const LogoContainer = styled.div`

display:flex;

align-items:center;

gap:1rem;

margin-bottom:1.5rem;

`;




const LogoIcon = styled.div`
  width: 58px;
  height: 58px;

  border-radius: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;

  overflow: hidden;

  box-shadow: 0 15px 30px rgba(15, 139, 66, 0.3);

  transition: 0.3s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 18px;
    display: block;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 18px 36px rgba(15, 139, 66, 0.4);
  }
`;




const BrandName = styled.div`

display:flex;

flex-direction:column;



.title{

font-size:1.35rem;

font-weight:900;

letter-spacing:-.5px;

}



.subtitle{

font-size:.72rem;

text-transform:uppercase;

letter-spacing:.12em;

color:#94A3B8;

}

`;





const BrandTagline = styled.p`

font-size:.95rem;

line-height:1.8;


color:#94A3B8;


margin-bottom:1.8rem;

`;






const SocialLinks = styled.div`

display:flex;

gap:.75rem;

`;




const SocialIcon = styled.a`

width:42px;

height:42px;


display:flex;

align-items:center;

justify-content:center;


border-radius:12px;


background:rgba(255,255,255,.08);


color:white;


font-size:1.1rem;


transition:.3s;



&:hover{

background:${({theme})=>theme.colors.primary};


transform:translateY(-5px);

}

`;






const ColumnTitle = styled.h4`

font-size:1.15rem;


font-weight:800;


margin-bottom:1.5rem;


position:relative;


padding-bottom:.7rem;



&::after{

content:"";

position:absolute;

left:0;

bottom:0;


width:45px;


height:3px;


border-radius:10px;


background:${({theme})=>theme.colors.primary};

}

`;





const LinkList = styled.ul`

list-style:none;


display:flex;

flex-direction:column;


gap:.9rem;

`;





const LinkItem = styled.li`


a{

display:flex;

align-items:center;

gap:.5rem;


font-size:.95rem;


color:#94A3B8;


transition:.3s;



&:hover{

color:white;

padding-left:6px;

}



}



`;






const ContactInfoList = styled.div`

display:flex;

flex-direction:column;

gap:1.1rem;

`;





const ContactItem = styled.div`

display:flex;

gap:.8rem;


align-items:flex-start;


color:#94A3B8;


font-size:.92rem;


line-height:1.6;



svg{

color:${({theme})=>theme.colors.primary};


margin-top:4px;


flex-shrink:0;

}



a{

color:#94A3B8;


&:hover{

color:white;

}

}



`;






const Divider = styled.div`

height:1px;

background:rgba(255,255,255,.1);

`;






const CopyrightBar = styled.div`

padding-top:1.8rem;


display:flex;


justify-content:space-between;


align-items:center;


gap:1rem;


font-size:.85rem;


color:#64748B;



@media(max-width:${({theme})=>theme.breakpoints.tablet}){

flex-direction:column;

text-align:center;

}

`;






export default function Footer(){


return(


<FooterWrapper>


<Container>



<FooterGrid>



<BrandColumn>


<LogoContainer>


<LogoIcon>
  <img
    src="https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Untitled_design_2_9c75ca29-926d-4f85-94dd-b01cbf3f47a0.png?v=1785696629"
    alt="Jisr Al Sahra Logo"
  />
</LogoIcon>



<BrandName>


<span className="title">

Jisr Al Sahra

</span>


<span className="subtitle">

Plaster & Tiles Cont.

</span>


</BrandName>


</LogoContainer>




<BrandTagline>


Delivering premium plastering, tiling, rendering, and architectural finishing solutions with precision craftsmanship across Sharjah and UAE.


</BrandTagline>





<SocialLinks>


<SocialIcon href="#" aria-label="LinkedIn">

<FiLinkedin/>

</SocialIcon>


<SocialIcon href="#" aria-label="WhatsApp">

<FiMessageCircle/>

</SocialIcon>



<SocialIcon href="#" aria-label="Facebook">

<FiFacebook/>

</SocialIcon>



<SocialIcon href="#" aria-label="Instagram">

<FiInstagram/>

</SocialIcon>



</SocialLinks>


</BrandColumn>







<div>


<ColumnTitle>

Quick Links

</ColumnTitle>



<LinkList>


<LinkItem>

<a href="#services">

<FiArrowRight/>

Services

</a>

</LinkItem>



<LinkItem>

<a href="#projects">

<FiArrowRight/>

Projects

</a>

</LinkItem>



<LinkItem>

<a href="#why-choose-us">

<FiArrowRight/>

Why Choose Us

</a>

</LinkItem>



<LinkItem>

<a href="#contact">

<FiArrowRight/>

Request Quote

</a>

</LinkItem>


</LinkList>



</div>








<div>



<ColumnTitle>

Contact Office

</ColumnTitle>




<ContactInfoList>



<ContactItem>

<FiPhone/>

<a href="tel:+971554688022">

+971 55 468 8022

</a>

</ContactItem>





<ContactItem>

<FiMail/>

<a href="mailto:jisralsahra@gmail.com">

jisralsahra@gmail.com

</a>

</ContactItem>






<ContactItem>


<FiMapPin/>


<span>

Office #132, Al Barajeel Business Center,
Al Nasiriya, Sharjah, UAE

</span>


</ContactItem>



</ContactInfoList>



</div>



</FooterGrid>





<Divider/>





<CopyrightBar>


<span>

© 2026 Jisr Al Sahra Plaster & Tiles Cont. All Rights Reserved.

</span>



<span>

SEDD Licensed Entity • License No. 945516

</span>



</CopyrightBar>



</Container>


</FooterWrapper>


);


}
